<template lang="pug">
#app.app--wrapper
  AppHeader
  router-view
  AppFooter
</template>

<script>
import AppHeader from "@/components/common/AppHeader";
import AppFooter from "@/components/common/AppFooter";
import {mapActions, mapMutations} from "vuex";

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
  },
  methods: {
    ...mapMutations({
      recoveryToken: 'auth/RECOVERY_TOKEN',
    }),
    ...mapActions({
      queryUserInfo: 'auth/queryUserInfo',
    }),
  },
  created() {
    this.recoveryToken();
    this.queryUserInfo();
  }
}
</script>

<style lang="scss">
html{
  //overflow-y: scroll;
}
</style>
